import { defineComponent as c, computed as a, openBlock as o, createElementBlock as l, normalizeClass as n, renderSlot as p, toDisplayString as f, createCommentVNode as b } from "vue";
/* empty css         */
const $ = /* @__PURE__ */ c({
  __name: "BaseBadge",
  props: {
    value: { default: 0 },
    max: { default: 99 },
    variant: { default: "standard" },
    color: { default: "red" },
    showZero: { type: Boolean, default: !1 },
    hidden: { type: Boolean, default: !1 },
    overlap: { default: "overlap" },
    anchorOrigin: { default: () => ({ vertical: "top", horizontal: "right" }) }
  },
  setup(s) {
    const e = s, u = a(() => e.hidden ? !1 : e.variant === "dot" || e.showZero ? !0 : e.value > 0), d = a(() => {
      if (e.variant !== "dot")
        return typeof e.value == "number" && e.value > e.max ? `${e.max}+` : e.value;
    }), i = a(() => e.variant === "square" ? "no-overlap" : e.overlap), t = a(() => e.variant === "square" ? { vertical: "middle", horizontal: "right" } : e.anchorOrigin), v = a(() => {
      const r = [
        "base-badge",
        `base-badge--${e.variant}`,
        `base-badge--${e.color}`,
        `base-badge--${i.value}`
      ];
      return r.push(`base-badge--${t.value.vertical}-${t.value.horizontal}`), r;
    });
    return (r, h) => (o(), l("div", {
      class: n(["base-badge-wrapper", `base-badge-wrapper--${e.overlap}`])
    }, [
      p(r.$slots, "default"),
      u.value ? (o(), l("span", {
        key: 0,
        class: n(v.value)
      }, f(d.value), 3)) : b("", !0)
    ], 2));
  }
});
export {
  $ as default
};
